export default __webpack_public_path__ + "media/images/noshis/butsunoshimihon-b32a46cebdbcc35c16e6b04ed14e41d9.jpg";